import { api, setCsrfToken } from './client'
import type { SessionResponse } from '../types/api'
import type { SessionUser } from '../types/api'

export type MockAccountId = 'creator_a' | 'creator_b' | 'creator_c'

type UserPayload = Partial<SessionUser> & Record<string, unknown>

function stringValue(value: unknown): string | undefined {
  return typeof value === 'string' && value.trim() ? value.trim() : undefined
}

/** 在 API 边界一次性规范化支持的用户资料别名。 */
export function normalizeSessionUser(value: unknown): SessionUser | undefined {
  if (!value || typeof value !== 'object') return undefined
  const raw = value as UserPayload
  const mid = stringValue(raw.bilibili_mid) || stringValue(raw.mid)
  const id = stringValue(raw.id) || mid
  if (!id) return undefined
  const nickname = stringValue(raw.nickname) || stringValue(raw.name) || stringValue(raw.uname)
  const avatarUrl = stringValue(raw.avatar_url) || stringValue(raw.face) || stringValue(raw.avatar)
  const profileStatus = stringValue(raw.profile_status)
  return {
    id,
    ...(mid ? { bilibili_mid: mid, mid } : {}),
    ...(nickname ? { name: nickname, nickname } : {}),
    ...(avatarUrl ? { face: avatarUrl, avatar_url: avatarUrl } : {}),
    ...(profileStatus ? { profile_status: profileStatus } : {}),
  }
}

function normalizeSession(session: SessionResponse): SessionResponse {
  const user = normalizeSessionUser(session.user || session.profile)
  if (user && !user.profile_status && session.profile_status) user.profile_status = session.profile_status
  return { ...session, user }
}

export async function getSession() {
  const session = normalizeSession(await api<SessionResponse>('/api/auth/session'))
  setCsrfToken(session.csrf_token)
  return session
}
export async function createMockSession(accountId: MockAccountId) {
  const result = await api<{ status: string; user?: SessionUser; csrf_token?: string; expires_at?: string }>('/api/auth/mock', {
    method: 'POST',
    body: JSON.stringify({ account_id: accountId }),
  })
  setCsrfToken(result.csrf_token)
  return result
}
export async function logout() { await api('/api/auth/logout', { method: 'POST' }); setCsrfToken() }
